export default class {
  static getStatus (pass) {
    if (!pass.NumTicket) {
      return 'outstanding'
    }
    if (!pass.Pan) {
      return 'pending-rgcc'
    }
    if (pass.Bloqueada) {
      return 'blocked'
    }
    if (pass.PendienteAprobacion) {
      return 'pending'
    }
    if (pass.Activada) {
      return 'active'
    }
    return 'inactive'
  }

  static getStatusName (status) {
    if (status === 'outstanding') {
      return 'Pendiente de pago'
    }
    if (status === 'pending-rgcc') {
      return 'Pendiente de validación del RGCC'
    }
    if (status === 'blocked') {
      return 'Bloquedado'
    }
    if (status === 'pending') {
      return 'Pendiente'
    }
    if (status === 'active') {
      return 'Activo'
    }
    if (status === 'inactive') {
      return 'Inactivo'
    }
    return null
  }
}
